export const SWAP_QUEUE_PREFILL_QUERY = {
  channelId: "channelId",
  channelIds: "channelIds",
  makeDefault: "makeDefault",
} as const;

export type SwapQueuePrefill = {
  channelIds: string[];
  makeDefault: boolean;
};

export function buildSwapQueuePrefillUrl(
  swapQueuePath: string,
  options: {
    channelId?: string;
    channelIds?: string[];
    makeDefault?: boolean;
  }
): string {
  const params = new URLSearchParams();
  if (options.channelIds?.length) {
    params.set(
      SWAP_QUEUE_PREFILL_QUERY.channelIds,
      options.channelIds.join(",")
    );
  } else if (options.channelId?.trim()) {
    params.set(SWAP_QUEUE_PREFILL_QUERY.channelId, options.channelId.trim());
  }
  if (options.makeDefault) {
    params.set(SWAP_QUEUE_PREFILL_QUERY.makeDefault, "1");
  }
  const qs = params.toString();
  return qs ? `${swapQueuePath}?${qs}` : swapQueuePath;
}

export function parseSwapQueuePrefill(search: string): SwapQueuePrefill | null {
  const params = new URLSearchParams(search);
  const channelId = params.get(SWAP_QUEUE_PREFILL_QUERY.channelId)?.trim();
  const channelIdsParam = params
    .get(SWAP_QUEUE_PREFILL_QUERY.channelIds)
    ?.trim();
  const makeDefaultRaw = params.get(SWAP_QUEUE_PREFILL_QUERY.makeDefault);
  const makeDefault =
    makeDefaultRaw === "1" ||
    makeDefaultRaw === "true" ||
    makeDefaultRaw === "yes";

  const channelIds: string[] = [];
  if (channelIdsParam) {
    channelIds.push(
      ...channelIdsParam
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean)
    );
  } else if (channelId) {
    channelIds.push(channelId);
  }

  if (!channelIds.length && !makeDefault) {
    return null;
  }

  return { channelIds, makeDefault };
}
